import request from '@/config/axios'

export interface PolicyAgreementVO {
  id?: number
  /** 兼容旧中文类型（律师页仍使用） */
  type?: string
  code?: string
  title?: string
  /** 兼容保留 */
  appId?: string
  /** 适用模块编码（模块管理 name），空=租户默认 */
  moduleCode?: string
  version?: string
  status?: number
  sort?: number
  remark?: string
  content: string
  createTime?: string
  updateTime?: string
}

export interface PolicyAgreementPageReq {
  pageNo?: number
  pageSize?: number
  type?: string
  code?: string
  title?: string
  appId?: string
  moduleCode?: string
  status?: number
  content?: string
}

export const PolicyAgreementApi = {
  getPage: (params: PolicyAgreementPageReq) =>
    request.get({ url: '/portal-ops/policy-agreement/page', params }),
  get: (id: number) => request.get({ url: '/portal-ops/policy-agreement/get', params: { id } }),
  create: (data: PolicyAgreementVO) => request.post({ url: '/portal-ops/policy-agreement/create', data }),
  update: (data: PolicyAgreementVO) => request.put({ url: '/portal-ops/policy-agreement/update', data }),
  delete: (id: number) => request.delete({ url: '/portal-ops/policy-agreement/delete', params: { id } })
}
